import ErrorBoundaryFallback from './error-boundary-fallback'

export default ErrorBoundaryFallback
